import { Component, Inject } from '@angular/core';
import { CalibrationBalance } from '../../../../model/calibrationBalance';
import { MyErrorStateMatcher } from '../../../../utils/errorStateMatcher';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

export interface DialogDataConfirmSave {
  calibration: CalibrationBalance;
  reason: string;
  showReason: boolean;
}

@Component({
  selector: 'app-calibration-balance-edit-confirm-save-component',
  templateUrl: './calibration-balance-edit-confirm-save.component.html',
  styleUrl: './calibration-balance-edit-confirm-save.component.scss',
  standalone: false
})
export class CalibrationBalanceEditConfirmSaveComponent {
matcher = new MyErrorStateMatcher();
  form: UntypedFormGroup;

  constructor(
    fb: UntypedFormBuilder,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CalibrationBalanceEditConfirmSaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmSave) {
    this.form = fb.group({
      reason: [this.data.reason, this.data.showReason ? [Validators.required] : []]
    });
  }

  onOkClick(): void {
    if (!this.form.valid) {
      this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.confirmSave.form.error.reason') as string);
      return;
    }

    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

